export default "__VITE_ASSET__4118b609__"